type Props = {
  countryCode: 'sv-SE';
  currency: 'SEK';
  value: string | number | null | undefined;
};

export const formatPrice = ({ countryCode, currency, value }: Props) => {
  if (value === null || value === undefined || value === '') return '-';
  if (!Number.isFinite(Number(value))) return `${value} kr`;

  return Intl.NumberFormat(countryCode, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
  }).format(Number(value));
};
